import { graphql } from "relay-runtime"

export const VitalSignFragment = graphql`
  fragment VitalSignFragment on VitalSign {
    bloodPressureDiastolic
    bloodPressureSystolic
    bloodSugarMgDl
    bloodSugarMmol
    bodyTemperature
    breathRate
    cReactiveProtein
    glasgowComaScaleEye
    glasgowComaScaleMotor
    glasgowComaScaleVerbal
    heartRate
    oxygenSaturation
    strepATestPositive
    visualAnalogPainScale
  }
`
